<script setup lang="ts">
import { ref } from 'vue';
import { cloneDeep } from 'lodash';
import Checkbox from 'primevue/checkbox';
import TourStatus from './TourStatus.vue';

const props = defineProps<{
  tourOnly: boolean;
  tourStatus: object;
  isEdit: boolean;
  targetLabel: string;
  checkboxLabel: string;
  isHideInstaQuote?: boolean;
  instaPermissions?: boolean;
  statusPermissions?: boolean;
}>();

const emits = defineEmits<{
  validateCheckbox: [value: boolean];
  validateSwitch: [event: any];
}>();

const tourTargets = ref(cloneDeep(props.tourStatus));
const validateCheckbox = () => {
  emits('validateCheckbox', !props.tourOnly);
};
const validateSwitch = (event: any) => {
  emits('validateSwitch', event);
};
</script>
<template>
  <div class="tour-target">
    <div class="mb-2 mt-4" v-if="!isEdit">{{ targetLabel }} <span class="text-primary">*</span></div>
    <div v-if="!isEdit" class="p-3 pb-0 border-dot-line">
      <div id="target-panel" class="field grid">
        <div class="col-4">
          <div class="flex gap-2">
            <Checkbox :modelValue="tourOnly" :binary="true" @update:modelValue="validateCheckbox()" />
            <div>{{ checkboxLabel }}</div>
          </div>
        </div>
        <div class="col-8 mt-2">
          <TourStatus :isHideInstaQuote="isHideInstaQuote" :instaPermissions="instaPermissions" :statusPermissions="statusPermissions" :data="tourTargets" @validateSwitch="validateSwitch($event)" />
        </div>
      </div>
    </div>
  </div>
</template>
